import React from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
	getSharingDetailsPopup,
	putUpdateCollaborators
} from '../../../../../../../actions/sharingDetailsActions';
import Button from "../../../../../../components/button";

class TransferOwnershipPopupMessage extends React.Component {

    constructor(props){
	    super(props);

	    this.proceed = this.proceed.bind(this);
    }

	proceed(){

        let toDelete = false;

		this.props.updateCollaborators.forEach((item) => {
			if(item.toRemove){
				toDelete = true;
			}
		});

		if(toDelete){

			/*
			* Waiting of the collaborator delete animation
			* */

			setTimeout(() => {
				this.props.putUpdateCollaborators({
					collaborators: this.props.updateCollaborators
				});
			}, 100);

		} else {
            this.props.putUpdateCollaborators({
                collaborators: this.props.updateCollaborators
            });
		}

		this.props.getSharingDetailsPopup([]);
    }

    render() {
	    return (
		    <div>
			    <h2>{this.props.t("textUnshareTitle")}</h2>
			    <p>{this.props.t("sharingDetailsPopupText1")}
							{this.props.t("sharingDetailsPopupText1")}</p>
			    <Button onClick={this.proceed} className="btn-danger float-right">{this.props.t("textContinue")}</Button>
			    <Button onClick={this.props.getBack} className="btn-default float-right mr-3">{this.props.t("getBackText")}</Button>
		    </div>
	    );
    }
}

const mapStateToProps = (state) => {
	return {
		updateCollaborators : state.sharingDetailsReducer.updateCollaborators,
		flash : state.sharingDetailsReducer.flash
	};
};


const mapDispatchToProps = (dispatch) => {
	return {
		putUpdateCollaborators : (boolean) => {
			dispatch(putUpdateCollaborators(boolean))
		},
        getSharingDetailsPopup : (boolean) => {
			dispatch(getSharingDetailsPopup(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TransferOwnershipPopupMessage));